var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "review" },
    [
      _c(
        "p",
        { staticClass: "v1-back-tip", staticStyle: { margin: "10px 0" } },
        [
          _c(
            "span",
            {
              staticStyle: { float: "left" },
              on: {
                click: function ($event) {
                  return _vm.$router.back()
                },
              },
            },
            [_c("i", { staticClass: "el-icon-arrow-left" }), _vm._v(" 返回 ")]
          ),
        ]
      ),
      _c(
        "div",
        { staticClass: "content" },
        [
          _vm.currentItem.images && _vm.currentItem.images.length > 0
            ? _c("div", { staticClass: "left" }, [
                _vm.visible
                  ? _c(
                      "div",
                      { staticClass: "image-preview" },
                      _vm._l(_vm.currentItem.images, function (img, jIndex) {
                        return _c(
                          "mark-image",
                          {
                            key: _vm.currentItem.detailId + "image" + jIndex,
                            attrs: { img: img, setting: _vm.setting },
                          },
                          [
                            _vm.showRawPaper
                              ? _c(
                                  "div",
                                  { style: _vm.iconStyle(img) },
                                  [
                                    _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          effect: "dark",
                                          content: "查看原卷",
                                          trigger: "hover",
                                          placement: "top-end",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "paper-preview",
                                            on: {
                                              click: function ($event) {
                                                return _vm.viewMosaic(
                                                  _vm.currentItem
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-search",
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        )
                      }),
                      1
                    )
                  : _vm._e(),
                _vm.currentItem.detailId
                  ? _c(
                      "div",
                      { staticClass: "zoom" },
                      [
                        _c("span", [_vm._v("缩放")]),
                        _c("span", { staticClass: "el-icon-minus" }),
                        _c("el-slider", {
                          attrs: { max: 300, min: 60 },
                          on: {
                            input: function ($event) {
                              _vm.setting.scale = _vm.setting.silderValue / 100
                            },
                          },
                          model: {
                            value: _vm.setting.silderValue,
                            callback: function ($$v) {
                              _vm.$set(_vm.setting, "silderValue", $$v)
                            },
                            expression: "setting.silderValue",
                          },
                        }),
                        _c("span", { staticClass: "el-icon-plus" }),
                        _c("span", [
                          _vm._v(_vm._s(_vm.setting.silderValue) + "%"),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
              ])
            : _c(
                "div",
                { staticClass: "left page-empty" },
                [_c("data-empty", { attrs: { loading: _vm.loading } })],
                1
              ),
          _c("yue-read-two-list", { staticClass: "right" }),
        ],
        1
      ),
      _c("el-image", {
        ref: "priview",
        staticClass: "priview-img",
        attrs: {
          src: _vm.previewImg.src,
          "preview-src-list": [_vm.previewImg.src],
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }